import script from "./tableContent.vue?vue&type=script&lang=jsx&setup=true"
export * from "./tableContent.vue?vue&type=script&lang=jsx&setup=true"

import "./tableContent.vue?vue&type=style&index=0&id=08a81cdd&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a81cdd"]])

export default __exports__